import axios from "axios";
const { REACT_APP_API_URL } = process.env;
axios.defaults.withCredentials = true;
import publicIp from "react-public-ip";

// set token to the axios
export const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    axios.defaults.headers.common["Appkey"] = "customer";
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};

// verify refresh token to generate new access token if refresh token is present
export const verifyTokenService = async () => {
  try {
    return await axios.post(`${REACT_APP_API_URL}/customer/verifyToken`);
  } catch (err) {
    return {
      error: true,
      response: err.message,
    };
  }
};

// user login API to validate the credential
export const userLoginService = async (
  email,
  password,
  language,
  createdBy,
  isSignUpByGoogle,
  isSignUpByFacebook,
) => {
  try {
    return await axios.post(`${REACT_APP_API_URL}/customer/login`, {
      email,
      password,
      language,
      createdBy,
      isSignUpByGoogle,
      isSignUpByFacebook,
    });
  } catch (err) {
    return {
      error: true,
      response: err?.response?.data?.message,
    };
  }
};

// manage user logout
export const userLogoutService = async () => {
  try {
    return await axios.post(`${REACT_APP_API_URL}/customer/logout`);
  } catch (err) {
    return {
      error: true,
      response: err.message,
    };
  }
};

/**
 * Exchange a signed impersonation grant for a session.
 *
 * The admin app used to put the customer's base64-encoded ObjectId straight in
 * the redirect URL and we posted it here. Base64 is an encoding, not a
 * signature, so that link was a working key to the account for anyone who could
 * construct one. The grant is minted by an authenticated staff request, is
 * single use, and expires in two minutes.
 */
export const userImpersonateService = async (token) => {
  try {
    return await axios.post(`${REACT_APP_API_URL}/customer/loginByAdmin`, {
      token,
    });
  } catch (err) {
    return {
      error: true,
      response: err?.response?.data?.message,
    };
  }
};

// Post-signup self-login, a DIFFERENT flow that happens to share this endpoint:
// the customer opening their own just-created account from the thank-you page.
// There is no staff actor to authorise it, so it cannot use a grant and still
// sends identifiers. That means it is still forgeable, and it is why the
// server's LEGACY_IMPERSONATION escape hatch cannot be switched off yet.
export const userLoginByAdminService = async (userId, createdBy) => {
  try {
    return await axios.post(`${REACT_APP_API_URL}/customer/loginByAdmin`, {
      userId,
      createdBy,
    });
  } catch (err) {
    return {
      error: true,
      response: err?.response?.data?.message,
    };
  }
};

// user login logs API to create logs
export const userLoginLogsService = async (customerId) => {
  try {
    if (!customerId) return;
    const ipv4 = (await publicIp.v4()) || "";
    return await axios.post(`${REACT_APP_API_URL}/customerLoginLogs/add`, {
      ip: ipv4,
      customerId,
    });
  } catch (err) {
    return {
      error: true,
      response: err.message,
    };
  }
};
